import { Injectable } from '@angular/core';
import { themeColorIsValid } from 'projects/lib-shared-common/src/public-api';
import { catchError, finalize, Observable, of, tap } from 'rxjs';

const DEFAULT_THEME = 'default';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private _theme: string = DEFAULT_THEME;

  get theme$(): string {
    return this._theme;
  }

  constructor() {}

  public handleThemeChange(theme: string): Observable<void> {
    const newTheme = themeColorIsValid(theme) ? theme : DEFAULT_THEME;

    return this.addStyleElementWithCssFilePath(newTheme).pipe(
      finalize(() => {
        document.body.classList.remove(`svc-${this._theme}`);
        document.body.classList.add(`svc-${newTheme}`);
        this._theme = newTheme;
      }),
      catchError(() => {
        return of(null);
      })
    );
  }

  private addStyleElementWithCssFilePath(theme: string): Observable<void> {
    return new Observable((s) => {
      const linkEl = document.createElement('link');
      linkEl.setAttribute('rel', 'stylesheet');
      linkEl.setAttribute('type', 'text/css');
      linkEl.href = `mat-theme-${theme}.css`;
      linkEl.onload = () => {
        s.next();
        s.complete();
      };
      linkEl.onerror = () => {
        s.error();
        s.complete();
      };
      document.head.appendChild(linkEl);
    });
  }
}
